export const HEADER_ROW_HEIGHT = 32;
export const ROW_HEIGHT = 35;

export interface SymbolRecord {
  amount?: number;
  amounType?: number;
  fundSymbol: string;
  fundName: string;
  itemIssueId: number;
  accountControlNumber: number;
  status: string;
  instructionContext: number;
  clndAuditIntgCntlNr: number;
  dayToExecute?: string;
  discretionaryInd?: boolean;
  duration?: string;
  endDate?: string;
  frequency?: string;
  solicitedInd?: boolean;
  startDate?: string;
  restartDate?: string;
  transactionType?: string;
  securityName?: string;
}

export const enum RecordType {
  Symbol = 'Symbol'
}

export interface ISymbolSearchCriteria {
  accountId?: string;
  itemIssueId?: number;
  searchTerm?: string;
}

export interface Record {
  accountName: string;
}

export interface IMdsSymbolSearchResponse {
  data: Array<IMdsSymbolSearchData>;
}

export interface IMdsSymbolSearchData {
  symbol: string;
  name: string;
  optionable: boolean;
  tradeable: boolean;
  assetType: string;
}
